import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import AddAdmin from './AddAdmin';
import AddSeller from './AddSeller';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';
import SchoolContext from '../../Reducers/Schools/SchoolContext';

export default function AddDeparture(props) {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;
   const { id } = props.match.params;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <AddAdmin {...props} id={id} />
			break;
		case '2':
			component = <AddSeller {...props} id={id} />
			break;
		case '3':
			component = <AddSeller {...props} id={id} />
			break;
		  default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
